import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';

import InventoryByItemList from '../../components/reports/InventoryByItemList';
import ReactPaginate from 'react-paginate';
import Spinner from '../../components/generics/Spinner';
import Filter from '../../components/generics/Filter';
import ReportHeader from '../../components/generics/ReportHeader';
import _ from 'lodash';

import {
  fetchInventoriedItems,
  fetchInventoriedItemsSuccess,
  fetchInventoriedItemsFailure,
  fetchInventoriedItemsCSV,
  fetchInventoriedItemsCSVSuccess,
  fetchInventoriedItemsCSVFailure,
} from "../../store/reports/actions";
import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class InventoryByItemListContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      search: '',
      selectedPlant: '',
      selectedLot: '',
      selectedStation: '',
    }

    this.changeSearch = _.debounce(() => {
      this.searchRefresh()
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const page = params.page ? params.page : STARTING_PAGE;
    const search = params.search ? params.search : this.state.search;
    const selectedPlant = params.plant ? params.plant : this.state.selectedPlant;
    const selectedLot = params.lot ? params.lot : this.state.selectedLot;
    const selectedStation = params.station ? params.station : this.state.selectedStation;

    this.setState({ page, search, selectedPlant, selectedLot, selectedStation }, () => {
      this.props.fetchInventoriedItems(page, search, selectedPlant, selectedLot, selectedStation);
    });

    this.props.fetchInventoriedItemsCSV(search, selectedPlant, selectedLot, selectedStation);

    // Fetch stations
    if (!this.props.stationsList.stations || this.props.stationsList.stations.length === 0) {
      this.props.fetchStations();
    }
  }

  onSearchChange = (event) => {
    let search = event.target.value ? event.target.value : '';
    this.setState({ search, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onPlantChange = (event) => {
    const selectedPlant = event.target.value ? event.target.value : "";
    this.setState({ selectedPlant }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const selectedLot = event.target.value ? event.target.value : "";
    this.setState({ selectedLot }, () => {
      this.changeSearch();
    });
  };

  onStationChange = (event) => {
    let selectedStation = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined;
    this.setState({ selectedStation }, () => {
      this.changeSearch();
    });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.changeSearch();
      });
    };
  };

  searchRefresh = () => {
    const { page, search, selectedPlant, selectedLot, selectedStation } = this.state
    this.props.fetchInventoriedItems(page, search, selectedPlant, selectedLot, selectedStation)
    this.props.fetchInventoriedItemsCSV(search, selectedPlant, selectedLot, selectedStation)
  };

  updateQueryString = () => {
    const { search, page, selectedPlant, selectedLot, selectedStation } = this.state;
    let params = {};
    if (search) params.search = search;
    if (selectedPlant) params.plant = selectedPlant;
    if (selectedLot) params.lot = selectedLot;
    if (selectedStation) params.station = selectedStation;
    params.page = page;
    this.props.history.push({ search: queryString.stringify(params) });
  };

    getGradeName = (data) => {
    data.forEach((item) => {
      if (item.grade && typeof item.grade === "object") {
        item.grade = item.grade.grade;
      }
    });
    return data;
  };

  render() {
    return (
      <div>
        <div className="card mb-2">
          <ReportHeader
            title="Inventory items grouped by item"
            actionTitle="Export CSV"
            actionClass="btn btn-primary m-0"
            headers={["item", "grade", "total_amount", "measure_unit", "count"]}
            csvData={this.getGradeName(this.props.inventoriedItemsCSV.itemsCSV)}
            filename={`inventoried_items_${moment().format("YMD")}.csv`}
          />
          <Filter
            searchLabel="Search"
            searchPlaceholder="Item Name"
            searchVal={this.state.search}
            onSearchChange={this.onSearchChange}
            searchLabel2="Plant"
            searchPlaceholder2="Search by plant"
            searchVal2={this.state.selectedPlant}
            onSearchChange2={this.onPlantChange}
            searchLabel3="Lot"
            searchPlaceholder3="Search by lot"
            searchVal3={this.state.selectedLot}
            onSearchChange3={this.onLotChange}
            dropdownLabel3="Station"
            dropdownPlaceholder3="All stations"
            dropdownVal3={this.state.selectedStation}
            onDropdownChange3={this.onStationChange}
            dropdownByElementId3
            dropdownOptions3={this.props.stationsList.stations.results}
            colClass="col-12 col-sm-3"
          />
        </div>
        <InventoryByItemList
          inventories={this.props.inventoriedItemsList.inventories}
          selectedPlant={this.state.selectedPlant}
          selectedLot={this.state.selectedLot}
          selectedStation={this.state.selectedStation}
        />
        {this.props.inventoriedItemsList.pages > 1 && (
          <ReactPaginate
            pageCount={this.props.inventoriedItemsList.pages}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            previousLabel="<"
            nextLabel=">"
            onPageChange={this.handlePageRequest}
            initialPage={this.state.page - 1}
            disableInitialCallback={true}
            containerClassName="pagination"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            activeClassName="page-item active"
            previousClassName="paginate_button previous"
            nextClassName="paginate_button next"
            disabledClassName="page-item disabled"
            forcePage={this.state.page - 1}
          />
        )}
        {this.props.inventoriedItemsList.loading ? <Spinner /> : null}
      </div>
    );}
}

const mapStateToProps = (state, ownProps) => {
  return {
    inventoriedItemsList: state.reports.inventoriedItemsList,
    currentUser: state.auth.currentUser,
    inventoriedItemsCSV: state.reports.inventoriedItemsCSV,
    stationsList: state.sessions.stationsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInventoriedItems: (page, search, selectedPlant, selectedLot, selectedStation) => {
      dispatch(fetchInventoriedItems(page, search, selectedPlant, selectedLot, selectedStation)).payload.then((response) => {
        dispatch(fetchInventoriedItemsSuccess(response.data))
      }, (error) => {
        dispatch(fetchInventoriedItemsFailure(error));
      });
    },
    fetchInventoriedItemsCSV: (search, selectedPlant, selectedLot, selectedStation) => {
      dispatch(fetchInventoriedItemsCSV(search, selectedPlant, selectedLot, selectedStation)).payload.then((response) => {
        dispatch(fetchInventoriedItemsCSVSuccess(response.data));
      }, (error) => {
        dispatch(fetchInventoriedItemsCSVFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InventoryByItemListContainer));
